import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view" },
    [
      _c(
        VBreadcrumbs,
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "company", params: {} } } },
            [_vm._v(" Company ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            { attrs: { to: { name: "companyView", params: {} } } },
            [_vm._v(" View Company ")]
          ),
        ],
        1
      ),
      _vm.loaded
        ? _c(
            VCard,
            [
              _c(VCardTitle, [_vm._v(" View Company ")]),
              _c(
                VCardText,
                [
                  _c(VSimpleTable, {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("tbody", [
                                _vm.company.name
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Name:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.company.name)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.thaiName
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Thai Name:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.company.thaiName)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.chineseName
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Chinese Name:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.company.chineseName)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.type
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Type:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.company.type)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.email
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Email:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.company.email)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.officeAddressEng
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Office Address (English): ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.officeAddressEng)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.officeAddressThai
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Office Address (Thai): ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.officeAddressThai)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.officePhone1
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Office Phone 1:")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.officePhone1)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.officePhone2
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Office Phone 2:")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.officePhone2)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.factoryAddressEng
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Factory Address (English): ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.factoryAddressEng)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.factoryAddressThai
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Factory Address (Thai): ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.factoryAddressThai)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.factoryPhone1
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Factory Phone 1: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.factoryPhone1)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.factoryPhone2
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" Factory Phone 2: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.factoryPhone2)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.company.isoCertifications
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v(" ISO Certifications: ")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.company.isoCertifications)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3465410535
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between ma-5" },
        [
          _c(VBtn, { on: { click: _vm.goBack } }, [_vm._v("Back")]),
          _c(
            VBtn,
            {
              attrs: { color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.edit(_vm.id)
                },
              },
            },
            [_vm._v("Edit")]
          ),
          _c("span"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }